import { render, staticRenderFns } from "./treasury_major.vue?vue&type=template&id=9dc223c8&"
import script from "./treasury_major.vue?vue&type=script&lang=js&"
export * from "./treasury_major.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports